import React from "react";
import {
  Box,
  Toolbar,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Drawer,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import { TREE_ICONS } from "../../constants/treeConfig";
import DesignTree from "../tree/DesignTree";
import StrategyTree from "../tree/StrategyTree";
import BuildTree from "../tree/BuildTree";

export const SIDEBAR_WIDTH = 280;

const CompanyValuesIcon = TREE_ICONS.companyValues;

function SidebarContent({ onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const isActive = (path) => location.pathname.startsWith(path);

  const activeStyle = {
    backgroundColor: "rgba(21, 101, 192, 0.08)",
    color: "#1565C0",
    fontWeight: 700,
    borderLeft: "3px solid #1565C0",
  };

  const handleNavigate = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  return (
    <Box sx={{ p: 1 }}>
      {/* 経営理念 */}
      <List dense disablePadding>
        <ListItemButton
          sx={{ ...(isActive("/design/company-values") ? activeStyle : {}) }}
          onClick={() => handleNavigate("/design/company-values")}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <CompanyValuesIcon color="primary" />
          </ListItemIcon>
          <ListItemText
            primary={t("tree.companyValues")}
            primaryTypographyProps={{ fontWeight: 600 }}
          />
        </ListItemButton>
      </List>

      <Divider sx={{ my: 0.5 }} />
      <DesignTree onNavigate={onClose} />

      <Divider sx={{ my: 0.5 }} />
      <StrategyTree onNavigate={onClose} />

      <Divider sx={{ my: 0.5 }} />
      <BuildTree onNavigate={onClose} />
    </Box>
  );
}

export default function TreeSidebar({ mobileOpen, onClose }) {
  const drawerSx = {
    width: SIDEBAR_WIDTH,
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: SIDEBAR_WIDTH,
      boxSizing: "border-box",
      borderRight: "1px solid #e0e0e0",
      bgcolor: "#fafafa",
    },
  };

  return (
    <Box component="nav">
      {/* モバイル: temporary Drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{ display: { xs: "block", md: "none" }, ...drawerSx }}
      >
        <Toolbar />
        <SidebarContent onClose={onClose} />
      </Drawer>

      {/* デスクトップ: permanent Drawer */}
      <Drawer
        variant="permanent"
        open
        sx={{ display: { xs: "none", md: "block" }, ...drawerSx }}
      >
        <Toolbar />
        <SidebarContent />
      </Drawer>
    </Box>
  );
}
